import React, { useMemo, type FC, type MouseEvent } from 'react'

//  import AnyChart from 'anychart-react/dist/anychart-react.min'
import AnyChart from 'Components/AnyChart'
import anychart from 'Helpers/anychart.setup'

import type { ChartItemData } from 'Pages/RecipientsOverview/types'
import { useIntl } from 'react-intl'

interface ChartProps {
  title: string
  data: ChartItemData[]
  id: string
}

const Chart: FC<ChartProps> = ({ title, data, id }) => {
  const intl = useIntl()

  const [chart, label] = useMemo(() => {
    const chart = anychart.pie(
      anychart.data
        .set(data)
        .mapAs({ x: 'label', value: 'value', fill: 'color' }),
    )

    chart.padding(0)

    chart.tooltip().useHtml(true)
    chart.tooltip().titleFormat('<span></span>')
    chart.tooltip().format(
      `<p style="font-family: Roboto; font-size: 13px; font-weight: 400;">
            <span style="padding-right: 10px; ">{%x}</span> <span>{%yPercentOfTotal}{numDecimals:2}%</span>
          </p>`,
    )

    chart.labels().fontFamily('Roboto')
    chart.labels().fontWeight(500)
    chart.labels().fontSize(14)
    chart.labels().format('{%yPercentOfTotal}{numDecimals:2}%')

    chart.interactivity().selectionMode('none')

    const label = anychart.standalones.label()
    label.text(title)
    label.width('100%')
    label.height('100%')
    label.hAlign('center')
    label.vAlign('middle')
    label.fontFamily('Roboto')

    const legend = chart.legend()
    legend.position('right')
    legend.align('center')
    legend.itemsLayout('vertical')
    legend.width('50%')
    legend.padding('0 0 0 0')
    legend.margin('0 0 0 32px')
    legend.fontFamily('Roboto')
    legend.fontSize(13)
    legend.itemsSpacing(8)
    legend.iconSize(20)
    legend.iconTextSpacing(8)

    legend.useHtml(true)
    legend.itemsFormat((item: ChartItemData) => {
      return `${item.x}:  ${intl.formatNumber(item.value, {
        maximumFractionDigits: 0,
      })}`
    })

    legend.listen('legendItemClick', (e: MouseEvent) => {
      e.preventDefault()
    })

    legend.listen('legendItemMouseOver', (e: any) => {
      legend.fontOpacity(0.3)
      const point = chart.getPoint(e.itemIndex)
      point.hovered(true)
      point.set('legendItem', { fontOpacity: 1 })
    })

    legend.listen('legendItemMouseOut', (e: any) => {
      const point = chart.getPoint(e.itemIndex)
      legend.fontOpacity(1)
      point.set('legendItem', null)
      point.hovered(false)
    })

    return [chart, label]
  }, [title, data])

  return (
    <AnyChart
      id={id}
      instance={chart}
      height={300}
      width="100%"
      center={{ content: label }}
      innerRadius="60%"
      left="15%"
      right="15%"
    />
  )
}

export default Chart
